
import styled from "styled-components";

export const ByodContainer = styled.div`
  width: ${({width}) => width}px;
  height: ${({height}) => height}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({center = true}) => center ? 'center' : 'flex-start'};
  @media only screen and (max-width: 545px){
   
  }
`;

 export const ByodImg = styled.div`
  width: 50px;
  height: 100px;
  border-style: solid;
  border-radius: 9px;
  border-width: 2px;
  border-color: #A7A7A7;
`;
